export default "__VITE_ASSET__CUn$QrfE__"